export default __webpack_public_path__ + "static/media/SmartControl.f03933a1.svg";